module.exports = __webpack_public_path__ + "img/202307_06.a7b83a4c.jpg";